import clsx from "clsx";
import type { ReactNode } from "react";

export function GdPositionVisibilityLegend() {
  return (
    <div className="gd-pos-visibility-legend" role="note" aria-label="Hinweis zur Feldsichtbarkeit">
      <div className="gd-pos-visibility-legend__item">
        <span className="gd-pos-visibility-badge gd-pos-visibility-badge--doc">Im Dokument</span>
        <span className="gd-pos-visibility-legend__text">
          Diese Angaben erscheinen auf dem Dokument für den Kunden.
        </span>
      </div>
      <div className="gd-pos-visibility-legend__item">
        <span className="gd-pos-visibility-badge gd-pos-visibility-badge--internal">Nur intern</span>
        <span className="gd-pos-visibility-legend__text">
          Nachkalkulation und Notizen — nicht im Kundendokument sichtbar.
        </span>
      </div>
    </div>
  );
}

export function GdPositionDocSection({
  title = "Im Dokument sichtbar",
  hint,
  children,
  className,
}: {
  title?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={clsx("gd-pos-section gd-pos-section--doc", className)}>
      <header className="gd-pos-section__header">
        <div>
          <div className="gd-pos-section__title-row">
            <h3 className="gd-pos-section__title">{title}</h3>
            <span className="gd-pos-visibility-badge gd-pos-visibility-badge--doc">Im Dokument</span>
          </div>
          {hint ? <p className="gd-pos-section__hint">{hint}</p> : null}
        </div>
      </header>
      <div className="gd-pos-section__body">{children}</div>
    </section>
  );
}

export function GdPositionInternalSection({
  title,
  hint,
  children,
  className,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={clsx("gd-pos-section gd-pos-section--internal", className)}>
      <header className="gd-pos-section__header">
        <div>
          <div className="gd-pos-section__title-row">
            <h3 className="gd-pos-section__title">{title}</h3>
            <span className="gd-pos-visibility-badge gd-pos-visibility-badge--internal">Nur intern</span>
          </div>
          {hint ? <p className="gd-pos-section__hint">{hint}</p> : null}
        </div>
      </header>
      <div className="gd-pos-section__body">{children}</div>
    </section>
  );
}

export function GdPositionDocPriceCard({
  title = "Preis auf dem Dokument",
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className="gd-pos-doc-price">
      <p className="gd-pos-doc-price__title">{title}</p>
      <div className="gd-pos-doc-price__body">{children}</div>
    </div>
  );
}
